(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kreatin-indhold"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('.rr-kre');
  if (!root) return;
  root.querySelectorAll('[data-bars]').forEach(function (el) {
    if (el.hasAttribute('data-plus')) { var p = document.createElement('span'); p.className = 'rr-kre__plus'; p.textContent = '+'; el.appendChild(p); }
    JSON.parse(el.getAttribute('data-bars')).forEach(function (v) {
      var bar = document.createElement('span'); bar.className = 'rr-kre__bar';
      if (v[1]) { var x = document.createElement('i'); x.className = 'x'; x.style.height = v[1] + '%'; bar.appendChild(x); }
      if (v[0]) { var b = document.createElement('i'); b.className = 'b'; b.style.height = v[0] + '%'; bar.appendChild(b); }
      el.appendChild(bar);
    });
  });
  var dlg = root.querySelector('[data-kre-dialog]');
  if (dlg) {
    var op = root.querySelector('[data-kre-open]'), cl = root.querySelector('[data-kre-close]');
    if (op) op.addEventListener('click', function () { dlg.showModal(); });
    if (cl) cl.addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
  }
  function measure() { root.classList.toggle('wide', root.clientWidth >= 900); }
  if ('ResizeObserver' in window) new ResizeObserver(measure).observe(root);
  measure();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["omega3-indhold"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var dirs = [[1, -0.6], [1, 0], [1, 0.6]];
    function init(root) {
      if (root.dataset.o3Ready) return;
      root.dataset.o3Ready = '1';
      var core = root.querySelector('.rr-o3__core');
      var cards = root.querySelectorAll('.rr-o3__card');
      var links = root.querySelectorAll('.rr-o3__links path');
      var dialog = root.querySelector('[data-o3-dialog]');

      // Ind-animation ved scroll
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) { root.classList.add('is-in'); io.disconnect(); } });
        }, { threshold: 0.2 });
        io.observe(root);
      } else { root.classList.add('is-in'); }

      function tilt(rx, ry, live) {
        core.classList.toggle('is-live', !!live);
        core.style.setProperty('--rx', rx.toFixed(2) + 'deg');
        core.style.setProperty('--ry', ry.toFixed(2) + 'deg');
      }
      function reset() {
        tilt(0, 0, false);
        root.classList.remove('is-smile');
        [].forEach.call(cards, function (c) { c.classList.remove('is-on'); });
        [].forEach.call(links, function (l) { l.classList.remove('is-on'); });
      }

      // Midterfeltet vipper efter musen, og fisken smiler
      core.addEventListener('mousemove', function (e) {
        var r = core.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5, py = (e.clientY - r.top) / r.height - 0.5;
        tilt(-py * 18, px * 18, true);
        root.classList.add('is-smile');
      });
      core.addEventListener('mouseleave', reset);

      // Hover på kort: linje og ikon aktiveres, midterfeltet vipper mod kortet
      [].forEach.call(cards, function (card) {
        var i = +card.dataset.i;
        card.addEventListener('mouseenter', function () {
          var d = dirs[i] || dirs[1], l = Math.hypot(d[0], d[1]);
          tilt(-(d[1] / l) * 14, (d[0] / l) * 14, false);
          root.classList.add('is-smile');
          [].forEach.call(cards, function (c) { c.classList.toggle('is-on', c === card); });
          [].forEach.call(links, function (p) { p.classList.toggle('is-on', +p.dataset.i === i); });
        });
        card.addEventListener('mouseleave', reset);
      });

      // Pop-up med fuld indholdsfortegnelse
      if (dialog) {
        var open = root.querySelector('[data-o3-open]');
        var close = root.querySelector('[data-o3-close]');
        if (open) open.addEventListener('click', function () { dialog.showModal(); });
        if (close) close.addEventListener('click', function () { dialog.close(); });
        dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
      }
    }
    function boot() { [].forEach.call(document.querySelectorAll('[data-rr-o3]'), init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rr-faq"] && !Shopify.designMode) return;
  try {
    
  class RrFaq extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        const toggle = event.target.closest('.rr-faq__toggle');
        if (!toggle || !this.contains(toggle)) return;

        const card = toggle.closest('.rr-faq__card');
        const wasOpen = card.dataset.open === 'true';

        this.querySelectorAll('.rr-faq__card').forEach((other) => {
          other.dataset.open = 'false';
          other.querySelector('.rr-faq__toggle')?.setAttribute('aria-expanded', 'false');
        });

        if (!wasOpen) {
          card.dataset.open = 'true';
          toggle.setAttribute('aria-expanded', 'true');
        }
      });
    }
  }

  if (!customElements.get('rr-faq')) {
    customElements.define('rr-faq', RrFaq);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rr-godt-at-vide"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.gvReady) return;
      root.dataset.gvReady = '1';
      var items = [].slice.call(root.querySelectorAll('.rr-gv__item'));
      if (!items.length) return;
      var total = String(items.length).padStart(2, '0');
      var prod = root.querySelector('[data-prod]'), meta = root.querySelector('[data-meta]');
      var pq = root.querySelector('[data-pq]'), pbody = root.querySelector('[data-pbody]'), ghost = root.querySelector('[data-ghost]');
      var mq = window.matchMedia('(min-width: 900px)');
      prod.textContent = root.dataset.product || '';
      meta.textContent = '01 / ' + total;

      function wide() { return mq.matches; }
      function show(i) {
        items.forEach(function (it, k) { it.classList.toggle('on', k === i); it.querySelector('.rr-gv__q').setAttribute('aria-expanded', String(k === i)); });
        var it = items[i], no = it.querySelector('.rr-gv__no').textContent;
        pq.textContent = it.querySelector('.rr-gv__qt').textContent;
        pbody.innerHTML = it.querySelector('.rr-gv__body').innerHTML;
        meta.textContent = no + ' / ' + total;
        ghost.textContent = no;
      }
      items.forEach(function (it, i) {
        var btn = it.querySelector('.rr-gv__q');
        btn.addEventListener('mouseenter', function () { if (wide()) show(i); });
        btn.addEventListener('focus', function () { if (wide()) show(i); });
        btn.addEventListener('click', function () {
          if (wide()) { show(i); return; }
          var open = !it.classList.contains('open');
          items.forEach(function (o) { o.classList.remove('open'); o.querySelector('.rr-gv__q').setAttribute('aria-expanded', 'false'); });
          if (open) { it.classList.add('open'); btn.setAttribute('aria-expanded', 'true'); }
        });
      });
      // Desktop: første spørgsmål vises i panelet fra start
      if (wide()) show(0);
      var onChange = function () { if (wide() && !items.some(function (it) { return it.classList.contains('on'); })) show(0); };
      if (mq.addEventListener) mq.addEventListener('change', onChange);
    }
    function boot() { [].forEach.call(document.querySelectorAll('[data-rr-gv]'), init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rr-home-dose"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function touch() { return window.matchMedia('(hover: none)').matches || window.innerWidth < 768; }
    function init(root) {
      if (root.dataset.rrReady) return;
      root.dataset.rrReady = '1';
      var cards = [].slice.call(root.querySelectorAll('.rr-dose__card'));
      function set(el) { cards.forEach(function (c) { c.classList.toggle('is-active', c === el); }); }
      cards.forEach(function (c) {
        c.addEventListener('mouseenter', function () { if (!touch()) set(c); });
        c.addEventListener('mouseleave', function () { if (!touch()) set(null); });
      });
      var raf = 0;
      function onScroll() {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = 0;
          if (!touch()) { return; }
          var mid = window.innerHeight / 2, best = null, bd = Infinity;
          cards.forEach(function (c) {
            var b = c.getBoundingClientRect();
            if (b.bottom < 0 || b.top > window.innerHeight) return;
            var d = Math.abs((b.top + b.bottom) / 2 - mid);
            if (d < bd) { bd = d; best = c; }
          });
          set(best);
        });
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      onScroll();
    }
    function boot() { [].forEach.call(document.querySelectorAll('[data-rr-dose]'), init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rr-nutrient-grid"] && !Shopify.designMode) return;
  try {
    
  class RrNutrientGrid extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;

      this.querySelector('[ref="openButton"]')?.addEventListener('click', () => this.dialog.showModal());
      this.querySelector('[ref="closeButton"]')?.addEventListener('click', () => this.dialog.close());

      // Klik på baggrunden lukker. <dialog> rapporterer klik på ::backdrop som
      // et klik på selve dialogen, så vi tjekker at målet ikke er indholdet.
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });
    }
  }

  if (!customElements.get('rr-nutrient-grid')) {
    customElements.define('rr-nutrient-grid', RrNutrientGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rr-om-os-side"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('.rr-om');
  if (!root) return;

  // Figurer
  var sg = root.querySelector('[data-streak]');
  for (var i = 0; i < 30; i++) { var c = document.createElement('i'); c.style.transitionDelay = (i * 45) + 'ms'; sg.appendChild(c); }
  var bp = root.querySelector('[data-bars]'), bars = [];
  for (var k = 0; k < 12; k++) {
    var b = document.createElement('i');
    b.style.background = k === 11 ? '#3F707A' : 'rgba(46,46,46,' + (0.25 + k * 0.06).toFixed(2) + ')';
    b.style.transitionDelay = (k * 70) + 'ms';
    b.dataset.h = (8 + Math.pow(k / 11, 1.6) * 88) + '%';
    bp.appendChild(b); bars.push(b);
  }

  // Breakpoints ud fra egen bredde
  function measure() { var w = root.clientWidth; [500, 600, 700, 900, 1000].forEach(function (n) { root.classList.toggle('w' + n, w >= n); }); }
  if ('ResizeObserver' in window) new ResizeObserver(measure).observe(root);
  measure();

  // Kapitelmenu
  var btns = root.querySelectorAll('[data-go]'), chs = root.querySelectorAll('[data-ch]');
  function setOn(i) { btns.forEach(function (b) { var on = +b.dataset.go === i; b.classList.toggle('on', on); if (on) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); }); }
  btns.forEach(function (b) {
    b.addEventListener('click', function () {
      var el = chs[+b.dataset.go];
      window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 70, behavior: 'smooth' });
      setOn(+b.dataset.go);
    });
  });

  // Animationer ved scroll
  function play(el) {
    el.classList.add('in');
    if (el.classList.contains('rr-om__bars')) bars.forEach(function (b) { b.style.height = b.dataset.h; });
  }
  if (!('IntersectionObserver' in window)) { root.querySelectorAll('[data-anim]').forEach(play); return; }
  var spy = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) setOn(+e.target.dataset.ch); }); }, { rootMargin: '-35% 0px -55% 0px' });
  chs.forEach(function (s) { spy.observe(s); });
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { setTimeout(function () { play(e.target); }, 200); io.unobserve(e.target); } });
  }, { threshold: 0.4 });
  root.querySelectorAll('[data-anim]').forEach(function (n) { io.observe(n); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rr-pakke-indhold"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-rr-pack]').forEach(function (root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      var f = {};
      root.querySelectorAll('[data-f]').forEach(function (el) { f[el.dataset.f] = el; });
      var tiles = Array.prototype.slice.call(root.querySelectorAll('.rr-pack__tile'));
      function select(t) {
        var d = t.dataset;
        f.no.textContent = d.no; f.stat.textContent = d.stat; f.unit.textContent = d.unit; f.dose.textContent = d.dose;
        f.name.textContent = d.name; f.kind.textContent = d.kind; f.content.textContent = d.content; f.claim.textContent = d.claim;
        f.linkname.textContent = d.name; f.url.setAttribute('href', d.url);
        tiles.forEach(function (x) {
          x.classList.toggle('is-active', x === t);
          x.setAttribute('aria-pressed', x === t ? 'true' : 'false');
        });
      }
      tiles.forEach(function (b) {
        var pick = function () { select(b); };
        b.addEventListener('mouseenter', pick); b.addEventListener('focus', pick); b.addEventListener('click', pick);
      });
      if (tiles.length) select(tiles[0]);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rr-routine-builder"] && !Shopify.designMode) return;
  try {
    
  class RrRoutineBuilder extends HTMLElement {
    connectedCallback() {
      this.tiers = (this.dataset.tiers || '').split(',').map((v) => parseInt(v, 10) || 0).filter((v) => v > 0);
      if (!this.tiers.length) this.tiers = [10, 15, 20, 25];
      this.days = Number(this.dataset.days) || 90;
      this.heights = [34, 46, 58, 70];
      this.silver = 'linear-gradient(115deg, #7E838A 0%, #E9EBEE 18%, #A3A8AF 36%, #F6F7F8 52%, #8A8F96 70%, #CDD0D4 86%, #A3A8AF 100%)';

      this.money = new Intl.NumberFormat('da-DK', { style: 'currency', currency: this.dataset.currency || 'DKK' });

      this.rows = Array.from(this.querySelectorAll('.rr-ud__row'));
      this.prods = this.rows.map((r) => ({
        el: r,
        name: r.dataset.name,
        price: Number(r.dataset.price) || 0, // øre
        color: r.dataset.color === 'silver' ? this.silver : r.dataset.color,
        light: r.dataset.light !== '0',
        img: r.dataset.img,
        art: { t: r.dataset.t, hh: r.dataset.hh, l: r.dataset.l, ww: r.dataset.ww, ar: r.dataset.ar },
        variant: Number(r.dataset.variantId) || 0,
        plan: r.dataset.sellingPlan || '',
        current: r.dataset.current === 'true',
      }));
      // Valgte produkter, i den rækkefølge de er valgt. Hovedproduktet står først.
      this.sel = this.prods.map((p, i) => (p.current ? i : -1)).filter((i) => i >= 0);

      this.listEl = this.querySelector('[data-list]');
      this.hintEl = this.querySelector('[data-hint]');
      this.submitEl = this.querySelector('[data-role="submit"]');
      this.errorEl = this.querySelector('[data-role="error"]');
      this.totalEl = this.querySelector('[data-total]');
      this.perDayEl = this.querySelector('[data-perday]');
      this.savedEl = this.querySelector('[data-saved]');

      this.#buildStairs();
      this.rows.forEach((row, i) => {
        // Kun Kreatin er sølv. De andre rækker bruger produktets egen farve (Essens er grå, ikke sølv).
        row.style.setProperty('--g', this.prods[i].color === this.silver
          ? this.silver
          : `linear-gradient(90deg, ${this.prods[i].color} 0%, ${this.prods[i].color} 60%, ${this.prods[i].color}E6 100%)`);
        row.addEventListener('click', () => {
          if (this.prods[i].current || row.disabled) return;
          const at = this.sel.indexOf(i);
          if (at >= 0) this.sel.splice(at, 1); else this.sel.push(i);
          this.#render();
        });
      });
      this.submitEl?.addEventListener('click', () => this.#addToCart());

      if ('ResizeObserver' in window) new ResizeObserver(() => this.#render()).observe(this);
      this.#render();
    }

    #money(øre) { return this.money.format(øre / 100); }

    #buildStairs() {
      this.stairsEl = this.querySelector('[data-stairs]');
      this.drops = [];
      this.steps = [];
      this.tiers.forEach((t, k) => {
        const d = document.createElement('div');
        d.className = 'rr-ud__drop';
        d.style.left = (k * 25) + '%';
        d.style.bottom = this.heights[k] + '%';
        d.innerHTML = '<i role="img"><img alt=""></i>';
        const s = document.createElement('div');
        s.className = 'rr-ud__step';
        s.style.left = (k * 25) + '%';
        s.style.height = this.heights[k] + '%';
        const n = k + 1;
        s.innerHTML = '<div class="rr-ud__face"><div class="rr-ud__fill"></div><span class="rr-ud__top"><span class="rr-ud__pct">' + t + ' %</span><span class="rr-ud__cap"><span class="s">' + n + ' stk.</span><span class="l">' + n + (n === 1 ? ' produkt' : ' produkter') + '</span></span></span><span class="rr-ud__name"></span></div>';
        this.stairsEl.appendChild(d);
        this.stairsEl.appendChild(s);
        this.drops.push(d);
        this.steps.push(s);
      });
    }

    #nameSize(k, p, isCur) {
      const roomy = this.clientWidth >= 700;
      const sH = roomy ? 420 : 290, pad = roomy ? 12 : 8;
      const pctPx = isCur ? (roomy ? 30 : 20) : (roomy ? 17 : 13);
      const capPx = (roomy ? 12 : 10.5) * 1.25;
      const avail = sH * this.heights[k] / 100 - 3 - pad * 2 - pctPx - 3 - capPx - 8;
      const base = roomy ? 16 : 12;
      return Math.max(8, Math.min(base, avail / (p.name.length * 0.74))).toFixed(1) + 'px';
    }

    #render() {
      const n = this.sel.length;
      const top = this.tiers.length;
      const pct = n ? this.tiers[Math.min(n, top) - 1] : 0;

      this.steps.forEach((s, k) => {
        const pi = this.sel[k];
        const has = pi !== undefined;
        const p = has ? this.prods[pi] : null;
        s.classList.toggle('has', has);
        s.classList.toggle('is-cur', k === Math.min(n, top) - 1);
        s.classList.toggle('is-light', has && p.light);
        if (has) s.style.setProperty('--c', p.color);
        const nm = s.querySelector('.rr-ud__name');
        if (has) { nm.textContent = p.name; nm.style.fontSize = this.#nameSize(k, p, k === Math.min(n, top) - 1); }
        this.drops[k].classList.toggle('has', has);
        if (has) {
          const holder = this.drops[k].querySelector('i');
          const img = holder.querySelector('img');
          if (img.getAttribute('src') !== p.img) img.setAttribute('src', p.img);
          img.setAttribute('alt', p.name);
          holder.style.setProperty('--ar', p.art.ar);
          ['t', 'hh', 'l', 'ww'].forEach((key) => holder.style.setProperty('--' + key, p.art[key]));
        }
      });

      let sum = 0;
      this.prods.forEach((p, i) => {
        const on = this.sel.indexOf(i) >= 0;
        const shown = on ? pct : this.tiers[Math.min(n + 1, top) - 1];
        if (on) sum += p.price;
        const r = p.el;
        r.classList.toggle('on', on);
        r.setAttribute('aria-pressed', String(on));
        const priceNow = p.price * (1 - shown / 100);
        r.querySelector('.rr-ud__price').textContent = this.#money(priceNow);
        r.querySelector('.rr-ud__day').textContent = '· ' + this.#money(priceNow / this.days) + '/dag';
        const act = r.querySelector('.rr-ud__act');
        if (!r.disabled) act.textContent = p.current ? '' : on ? 'Tilføjet' : '+ ' + shown + ' %';
      });

      const disc = sum * pct / 100;
      if (this.totalEl) this.totalEl.textContent = this.#money(sum - disc);
      if (this.perDayEl) this.perDayEl.textContent = this.#money((sum - disc) / this.days);
      if (this.savedEl) this.savedEl.textContent = this.#money(disc);

      const cur = this.prods.find((p) => p.current);
      const next = n < top ? this.tiers[n] : null;
      if (this.hintEl) {
        this.hintEl.textContent = n <= 1
          ? `Start abonnement og få ${this.tiers[0]} % på ${cur ? cur.name : 'dit produkt'}. Læg 1 produkt mere i og få ${this.tiers[1] || this.tiers[0]} % på det hele.`
          : next ? `Læg 1 produkt mere i og få ${next} % på det hele.` : `Du er på toppen af stigen: ${this.tiers[top - 1]} % på det hele.`;
      }
      if (this.submitEl) this.submitEl.disabled = n === 0;
    }

    async #addToCart() {
      // Alt lægges i kurven i ét kald med hver sin abonnementsplan, så det
      // bliver én abonnementsordre og ikke en blanding af engangskøb og abonnement.
      const items = [];
      this.sel.forEach((i) => {
        const p = this.prods[i];
        if (p.variant && p.plan) items.push({ id: p.variant, quantity: 1, selling_plan: Number(p.plan) });
      });

      if (!items.length) {
        if (this.errorEl) this.errorEl.textContent = this.dataset.missingPlanText || '';
        return;
      }

      this.submitEl.disabled = true;
      if (this.errorEl) this.errorEl.textContent = '';

      try {
        // Theme er erklæret med `const` i et klassisk script — den findes i det
        // globale lexical scope, men ikke som window.Theme.
        const cartAddUrl =
          (typeof Theme !== 'undefined' && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';

        const response = await fetch(cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
        const data = await response.json();

        if (!response.ok) {
          if (this.errorEl) this.errorEl.textContent = data.description || data.message || '';
          return;
        }

        // Samme event som temaets egen produktformular sender, så kurv-ikon,
        // kurv-skuffe og totaler opdaterer sig.
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: data,
              sourceId: this.id || 'rr-routine-builder',
              data: { source: 'rr-routine-builder', itemCount: items.length },
            },
          })
        );

        // Tilvalg nulstilles; hovedproduktet er altid valgt.
        this.sel = this.prods.map((p, i) => (p.current ? i : -1)).filter((i) => i >= 0);
      } catch (error) {
        console.error(error);
        if (this.errorEl) this.errorEl.textContent = 'Kunne ikke lægge i kurv. Prøv igen.';
      } finally {
        this.#render();
      }
    }
  }

  if (!customElements.get('rr-routine-builder')) {
    customElements.define('rr-routine-builder', RrRoutineBuilder);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rr-videnskab-side"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-rr-sci]').forEach(function (root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      var list = root.querySelector('[role="tablist"]'), ind = root.querySelector('.rr-sci__ind');
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
      var panels = tabs.map(function (t) { return root.querySelector('#' + t.getAttribute('aria-controls')); });
      function place(t) { ind.style.width = t.offsetWidth + 'px'; ind.style.transform = 'translateX(' + t.offsetLeft + 'px)'; }
      function select(t, opts) {
        opts = opts || {};
        tabs.forEach(function (x, i) {
          var on = x === t;
          x.setAttribute('aria-selected', on ? 'true' : 'false');
          if (on) x.removeAttribute('tabindex'); else x.setAttribute('tabindex', '-1');
          panels[i].hidden = !on;
          panels[i].classList.remove('is-in');
          if (on) { void panels[i].offsetWidth; panels[i].classList.add('is-in'); }
        });
        place(t);
        if (opts.focus) t.focus();
        if (opts.hash && history.replaceState) history.replaceState(null, '', '#' + t.dataset.id);
        if (t.scrollIntoView && opts.focus !== undefined) t.scrollIntoView({ block: 'nearest', inline: 'center' });
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(t, { hash: true, focus: false }); });
        t.addEventListener('keydown', function (ev) {
          var n = ev.key === 'ArrowRight' ? i + 1 : ev.key === 'ArrowLeft' ? i - 1 : ev.key === 'Home' ? 0 : ev.key === 'End' ? tabs.length - 1 : null;
          if (n === null) return;
          ev.preventDefault();
          select(tabs[(n + tabs.length) % tabs.length], { hash: true, focus: true });
        });
      });
      var start = tabs.filter(function (t) { return '#' + t.dataset.id === location.hash; })[0] || tabs[0];
      ind.style.transition = 'none';
      select(start);
      root.classList.add('is-ready');
      requestAnimationFrame(function () { ind.style.transition = ''; });
      window.addEventListener('resize', function () { place(root.querySelector('[aria-selected="true"]')); });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { place(root.querySelector('[aria-selected="true"]')); });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
